module.exports = __webpack_public_path__ + "static/media/sh1Back.cd5aea0f.png";